import * as React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

class Note extends React.Component {
  render() {
    const minWidth = this.props.minWidth ? `min-w${this.props.minWidth}` : null;
    const maxWidth = this.props.maxWidth ? `mw${this.props.maxWidth}` : null;
    const align = this.props.align;

    const alignMap = {
      left: "tl",
      right: "tr",
      center: "tc",
      justified: "tj"
    };

    const alignment = alignMap[align];

    let noteClass = classNames(
      "mt0",
      "sans-serif",
      this.props.color,
      this.props.weight,
      this.props.fontStyle,
      this.props.textOverflow,
      minWidth,
      maxWidth,
      {
        f6: !this.props.responsive,
        f7: this.props.responsive,
        "f6-l": this.props.responsive,
        nowrap: this.props.nowrap
      },
      { db: !this.props.inline, dib: this.props.inline },
      { mb2: !this.props.inline, mb0: this.props.inline },
      alignment
    );
    return (
      <p
        className={noteClass}
        style={{
          whiteSpace: this.props.whiteSpace,
          overflowWrap: this.props.overflowWrap,
          lineHeight: this.props.lineHeight
        }}
      >
        {this.props.children}
      </p>
    );
  }
}

Note.defaultProps = {
  color: "black-60",
  weight: "normal",
  fontStyle: "fs-normal",
  inline: false,
  responsive: false,
  nowrap: false,
  align: "left",
  lineHeight: "1.45"
};

Note.propTypes = {
  color: PropTypes.string,
  weight: PropTypes.string,
  fontStyle: PropTypes.string,
  align: PropTypes.oneOf(["left", "right", "center", "justified"]),
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf([PropTypes.node])
  ]),
  inline: PropTypes.bool,
  whiteSpace: PropTypes.string,
  textOverflow: PropTypes.string,
  overflowWrap: PropTypes.string,
  minWidth: PropTypes.oneOf([1, 2, 3, 4, 5]),
  maxWidth: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9]),
  responsive: PropTypes.bool,
  nowrap: PropTypes.bool,
  lineHeight: PropTypes.string
};

export default Note;
